import { isMobileAppPlatform } from './isMobileAppPlatform';
import { navigateTo, openInNewTab } from './navigation';

// Hand off to a partner URL, branching on the platform query param. The native
// iOS/Android in-app browser has no "new tab" concept, so a `window.open`
// either silently drops or prompts the user to leave the host app; on those
// clients we navigate the same view instead. Web continues to open a new tab.
//
// `preOpenedTab` is for callers that hand off *after* async work (e.g. a server
// validate): Safari only honours `window.open('_blank')` synchronously inside a
// user gesture, so those callers open a blank tab during the click and pass the
// handle here to redirect it. We null `opener` before navigating so the partner
// site can't reach back into this window (the equivalent of `noopener`, which we
// can't pass to the original `window.open` because it returns null and leaves no
// handle to redirect).
export const openOrNavigate = (
  url: string,
  platform: string | string[] | undefined,
  preOpenedTab?: Window | null,
) => {
  if (isMobileAppPlatform(platform)) {
    navigateTo(url);
    return;
  }
  if (preOpenedTab) {
    preOpenedTab.opener = null;
    preOpenedTab.location.href = url;
    return;
  }
  openInNewTab(url);
};
